import { useInfiniteQuery } from '@tanstack/react-query';

import { getAllSessionsAPI } from './get-sessions';

const CALENDAR_SESSION_PAGE_SIZE = 100;

export function useGetAllCalendarSessions() {
  return useInfiniteQuery({
    queryKey: ['calendar-sessions', 'all'],
    queryFn: ({ pageParam }) =>
      getAllSessionsAPI({
        page: pageParam,
        limit: CALENDAR_SESSION_PAGE_SIZE,
      }),
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      const { page, totalPages } = lastPage.pagination;
      return page < totalPages ? page + 1 : undefined;
    },
  });
}
